import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { Typography } from 'enova-frontend-components';

import DismissableInfoBox from '../../../components/dismissableInfoBox';
import { useUser } from '../../../hooks/useUser';
import SearchView from '../buildings/components/searchView';

export const SearchTabContent = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const headerText = t('mainScreen.tab.sok', {
    context: user?.type
  });

  return (
    <React.Fragment>
      <Helmet title={headerText} />
      <DismissableInfoBox localStorageKey={user?.userId} title={t('mainScreen.findBuilding.info.title')}>
        {t('mainScreen.findBuilding.info.content')}
      </DismissableInfoBox>

      <Typography variant="h2" mb={3}>
        {headerText}
      </Typography>
      <SearchView />
    </React.Fragment>
  );
};
